import {Component, Input} from '@angular/core';
import {Subscription} from "rxjs";
import {finalize} from "rxjs/operators";

import {Homonym} from '../../models/homonym.model';
import {VoiceService} from '../../services/voice/voice.service';
import {GlobalEventService} from "../../services/global-event/global-event.service";


@Component({
  selector: 'app-homonym-all-play-btn',
  template: `
    <a *ngIf="canPlayAll"
       class="gather-btn"
       (click)="playSound($event)">
      <span class="txt">모아서 들어보기</span>
      <i class="ic ic-listen {{ ing ? 'on' : '' }}"></i>
    </a>

  `,
  styleUrls: ['./homonym-all-play-btn.component.scss'],
  host: {
    '[class]': 'canPlayAll ? "list-item-box type-gather play-all-btn" : ""',
  },
})
export class HomonymAllPlayBtnComponent {
  @Input() homonym?: Homonym;

  playAll$: Subscription | null = null;

  constructor(
    private voice: VoiceService,
    private globalEventSvc: GlobalEventService,
  ) { }

  playSound($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event, true);

    if (!this.homonym) {
      throw new Error('HomonymAllPlayBtnComponent::playSound() homonym is undefined');
    }
    if (this.homonym.hasVoice) {
      if (this.playAll$ && this.voice.homonymId === this.homonym.name) {
        this.playAll$.unsubscribe();
        this.playAll$ = null;
      }
      else {
        this.playAll$ = this.voice.PlayHomonym(this.homonym).pipe(
          finalize(() => this.playAll$ = null)
        ).subscribe(num => console.log('HomonymAllPlayBtnComponent::playSound()', num));
      }
    }
    else {
      console.error('HomonymAllPlayBtnComponent::playSound() homonym has no voice');
    }
  }

  /**
   * 2개 이상의 단어가 소리를 가지고 있으면, 모아서 들어보기가 켜진다.
   */
  public get canPlayAll(): boolean {
    if (this.homonym) {
      let numWordSound = 0;
      this.homonym.listWord.forEach(word => numWordSound += word.wordVoice ? 1 : 0);
      return numWordSound >= 2;
    }
    else {
      return false;
    }
  }

  /**
   * 현재 모아서 들어보기가 재생중인지 여부를 반환한다.
   */
  public get ing(): boolean {
    return !!this.playAll$ && 
           !!this.homonym?.name && 
           this.voice.homonymId === this.homonym.name;
  }
}
